﻿(function () {
    'use strict';

    var serviceId = 'repository.appmntCtainerEntryEdit';

    angular
        .module('app.services')
        .factory(serviceId, appmntCtainerEntryEdit);

    appmntCtainerEntryEdit.$inject = ['common', 'repository.abstract'];

    function appmntCtainerEntryEdit(common, abstractRepository) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;

            this.myFunction = myFunction;
        }
        abstractRepository.extend(Ctor);

        return Ctor;

        function myFunction() {

        }

    }
})();